// Utilities to keep plan naming consistent between legacy plans and Pluss.

export const normalizePlanName = (plan) => {
  if (!plan) return "";
  const value = String(plan).trim().toLowerCase();
  if (["free", "basic", "guest", "anonymous"].includes(value)) {
    return "free";
  }
  if (value === "pro") {
    return "pro";
  }
  if (["pluss", "plus", "tutor", "premium", "paid"].includes(value)) {
    return "pluss";
  }
  return "free";
};

export const hasPlussAccess = (plan) =>
  ["pluss", "pro"].includes(normalizePlanName(plan));
